var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spin-container"},[_c('div',{staticClass:"spin-element"}),_c('div',{staticClass:"spin-element"}),_c('div',{staticClass:"spin-element"}),_c('div',{staticClass:"spin-element"})])])
}]

export { render, staticRenderFns }